import { isPlatformServer } from "@angular/common";
import { Inject, NgModule, PLATFORM_ID } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { ICON_FILENAMES } from "../data/icons";

@NgModule({})
export class PbIconModule {
	constructor(
		private domSanitizer: DomSanitizer,
		private matIconRegistry: MatIconRegistry,
		@Inject(PLATFORM_ID) private platformId: string,
	) {
		if (isPlatformServer(this.platformId)) {
			Object.entries(ICON_FILENAMES).forEach(
				([iconName, iconFilename]) => {
					this.matIconRegistry.addSvgIconLiteral(
						iconName,
						this.domSanitizer.bypassSecurityTrustHtml(
							"<svg></svg>",
						),
					);
				},
			);
		} else {
			Object.entries(ICON_FILENAMES).forEach(
				([iconName, iconFilename]) => {
					this.matIconRegistry.addSvgIcon(
						iconName,
						this.setPath(iconFilename),
					);
				},
			);
		}
	}

	private setPath(fileName: string): SafeResourceUrl {
		return this.domSanitizer.bypassSecurityTrustResourceUrl(
			`assets/icons/${fileName}.svg`,
		);
	}
}
